import axios from "axios";

const getExportScanTrackSummary = async (params) => {
  try {
    const response = await axios.post(
      "/consumer/system-admin/api/v1/data-summary/export-scan-track-summary",
      params, // send params as the POST body
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        responseType: "blob", // important for file downloads!
      }
    );
    return response;
  } catch (error) {
    const errorResponse = {
      success: false,
      error: error.response?.data?.message || error.message,
      code: error.response?.data?.code || "ERROR_UNKNOWN",
      data: [],
      details: error.response?.data?.data || null,
    };
    console.error("API Error Details:", errorResponse);
    throw errorResponse;
  }
};

export default getExportScanTrackSummary;
